/**
 * Entry point for Webpack
 */
import '../node_modules/video.js/dist/video-js.css';
import videojs from "expose-loader?exposes=$,videojs!../node_modules/video.js/dist/video.js";
//import videojs from '../node_modules/video.js/dist/video.js';

import RaiVideoPlayer from "./js/app.js";

export default function _RaiVideoPlayer(playerId,playerOptions) {
    const player = new RaiVideoPlayer(videojs,playerId,playerOptions);
    return player;
}
